import { getPricingApiConfig } from '../config/actions';
import { uppercaseMarketRegion } from '../../../common/utilities/uppercase-market-region';
/**
 * @internal
 */
export var getFetchSFCCPricesUrlGetBySkus = function (productSkus) {
    var _a = getPricingApiConfig(), marketLocale = _a.marketLocale, baseUrl = _a.baseUrl;
    var sfccLocale = uppercaseMarketRegion(marketLocale);
    var productSkusQueryParameter = productSkus.length > 1 ? "(" + productSkus.join(',') + ")" : productSkus[0] + "/prices";
    return baseUrl + "/products/" + productSkusQueryParameter + "?c_method=getPrices&locale=" + sfccLocale;
};
